/**
 * Mirrors System.DayOfWeek serialized as PascalCase strings via JsonStringEnumConverter.
 */
export enum DayOfWeek {
  Sunday = "Sunday",
  Monday = "Monday",
  Tuesday = "Tuesday",
  Wednesday = "Wednesday",
  Thursday = "Thursday",
  Friday = "Friday",
  Saturday = "Saturday",
}

export const DAYS_OF_WEEK: DayOfWeek[] = [
  DayOfWeek.Monday,
  DayOfWeek.Tuesday,
  DayOfWeek.Wednesday,
  DayOfWeek.Thursday,
  DayOfWeek.Friday,
  DayOfWeek.Saturday,
  DayOfWeek.Sunday,
];

/** Convert JS Date.getDay() (0=Sun..6=Sat) to a DayOfWeek string. */
export const dayOfWeekFromJsIndex = (index: number): DayOfWeek => {
  switch (index) {
    case 0: return DayOfWeek.Sunday;
    case 1: return DayOfWeek.Monday;
    case 2: return DayOfWeek.Tuesday;
    case 3: return DayOfWeek.Wednesday;
    case 4: return DayOfWeek.Thursday;
    case 5: return DayOfWeek.Friday;
    case 6: return DayOfWeek.Saturday;
    default: return DayOfWeek.Sunday;
  }
};
